import React, { useRef } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import useHttp from "../../hooks/useHttp";
import Interval from "../../models/communications/Interval";
import LinearProgress from "@mui/material/LinearProgress";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuList from "@mui/material/MenuList";
import FilterNoneOutlinedIcon from "@mui/icons-material/FilterNoneOutlined";
import { useRowSelector, useStoreDispatch, useStoreSelector } from "../../store/Hooks";
import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import { navSliceActions } from "../../store/slices/NavSlice";
import { useEffect, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import EditorWrapper from "../ui/EditorWrapper";
import { stateDeepCopy } from "../../helpers/DataUpdateHelper";
import CommunicationSetEditor from "./CommunicationSetEditor";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Interaction from "../../models/interactions/Interaction";
import IntervalSet from "../../models/communications/IntervalSet";
import InteractionParentInterval from "../../models/interactions/InteractionParentInterval";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Divider } from "@mui/material";
import GridOnIcon from "@mui/icons-material/GridOn";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { Tooltip } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CommunicationSet from "../../models/communications/CommunicationSet";
import IntervalToCommSetButtonAndMenu from "./SchedulingMatrix/controls/IntervalToCommSetButtonAndMenu";
import { postgrest_operators } from "../../helpers/HttpHelper";

const testing = process.env.REACT_APP_TEST_MODE === "test";

interface IntervalsEditorProps {
  interval: Interval;
  inDrawer?: boolean;
  interactionParentInterval?: InteractionParentInterval | null;
  intervalSet?: IntervalSet | null;
  intervalSetEditMode?: boolean;
  parent?: number;
  new?: boolean;
}

const IntervalsEditor = (props: IntervalsEditorProps) => {
  // console.log(props)
  const dispatch = useStoreDispatch();
  const inputRef = useRef(null);

  const interval = useRowSelector(Interval, props.interval.id);
  console.log(interval)
  const commSet = useRowSelector(CommunicationSet, interval?.communication_set_id || 0);
  console.log(commSet)



  const [intervalName, setIntervalName] = useState<string>(props.interval.name);

  // if intital text, highlight the name to "suggest" changing it
  // otherwise, dont highlight and move cursor to end
  const handleHighlightClick = () => {
    // Set the selection range to highlight the text
    if (inputRef.current && intervalName == "New Interval Name") {
      inputRef.current.select();
    } else {
      if (inputRef.current) {
        inputRef.current.focus();

        // Move the cursor to the end of the text
        inputRef.current.setSelectionRange(
          inputRef.current.value.length,
          inputRef.current.value.length,
        );
      }
    }
  };


  const handleOpenEditCommunications = () => {
    interval?.update('communication_set_id',null)
    dispatch(
      navSliceActions.openRightDrawer({
        content: null,
        type: "communications",
        resourceID: thisInterval.id,
        resourceName: "interval",
        extraData: { editMode: true },
      }),
    );
  };

  const { isLoading, sendRequest: fetchData } = useHttp();

  const intervals = useStoreSelector(
    (state) => state.interactionTree.Intervals,
  );
  const intervalsObjIndex = intervals.findIndex(
    (obj) => obj.id === props.interval.id,
  );
  const thisInterval: Interval = stateDeepCopy(intervals[intervalsObjIndex]);

  let thisCommSet: CommunicationSet | null = null;
  const communicationSets = useStoreSelector(
    (state) => state.interactionTree.CommunicationSets,
  );
  const commSetsObjIndex = communicationSets.findIndex(
    (obj) => obj.id === props.interval.communication_set_id,
  );
  if (commSetsObjIndex && commSetsObjIndex != -1) {
    thisCommSet = stateDeepCopy(communicationSets[commSetsObjIndex]);
  }

  // updating intervals must save to redux state, since interactions are handled there
  const handleIntervalNameMapping = (value: any) => {
    dispatch(
      interactionTreeSliceActions.updateInterval({
        id: props.interval.id,
        name: value,
      }),
    );
  };
  // updating intervals must save to redux state, since interactions are handled there
  const handleIntervalSetMapping = (value: any) => {
    dispatch(
      interactionTreeSliceActions.updateInterval({
        id: props.interval.id,
        interval_set_id: value,
      }),
    );
  };
  // updating intervals must save to redux state, since interactions are handled there
  const handleCommunicationSetMapping = (value: any) => {
    dispatch(
      interactionTreeSliceActions.updateInterval({
        id: props.interval.id,
        communication_set_id: value,
      }),
    );
  };

  // updating intervals must save to redux state, since interactions are handled there
  const handleStartDayMapping = (value: any) => {
    const startDay = value;
    dispatch(
      interactionTreeSliceActions.updateInterval({
        id: props.interval.id,
        start_day: startDay,
      }),
    );
  };

  // updating intervals must save to redux state, since interactions are handled there
  const handleEndDayMapping = (value: any) => {
    const endDay = value;
    dispatch(
      interactionTreeSliceActions.updateInterval({
        id: props.interval.id,
        end_day: endDay,
      }),
    );
  };


  useEffect(() => {
    handleHighlightClick();
  }, []);

  // updating interactions must save to redux state, since interactions are handled there
  const save = async () => {
    const objIndex = intervals.findIndex((obj) => obj.id === props.interval.id);
    const thisInterval: Interval = intervals[objIndex];

    const data = thisInterval;
    const url: string =
      process.env.REACT_APP_API_URL + "/interval?id=eq." + props.interval.id;
    const requestSettings = {
      url: url,
      method: "PUT",
      body: data,
      headers: {
        Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
        "Content-Type": "application/json",
        "Content-Profile": testing ? "test" : "build"
      },
    };
    if (process.env.REACT_APP_DEV_MODE === "OFF") {
      fetchData(requestSettings);
    }
  };

  const handleCloseWithoutSaving = async () => {
    // if we are closing without saving, we should revert redux UI for this interval
    // just pull the saved db state for this, and update the interval in redux with initial state
    Interval.queryTable([
      {
        column: "id",
        operator: postgrest_operators.eq,
        value: props.interval.id.toString(),
      },
    ]);

  };

  let intervalSetID: null | number = null;
  if (props.interval.interval_set_id) {
    intervalSetID = props.interval.interval_set_id;
  }

  const intervalsForThisIntervalSet = intervals.filter((interval) => {
    return interval.interval_set_id === intervalSetID
  })

  const commSetsForThisIntervalSet = communicationSets.filter((commSet) => {
    return intervalsForThisIntervalSet.findIndex((interval) => {
      return commSet.id === interval.communication_set_id
    }) !== -1
  })

  return (
    <EditorWrapper
      save={save}
      cancel={handleCloseWithoutSaving}
      title={props.new ? "Adding Interval " + props.interval.name : "Edit Interval " + props.interval.name}
      inDrawer={props.inDrawer}
    >
      <Box data-testid="intervalEditorTest">
        <Grid container style={{}}>
          <Grid item xs={12} style={{}}>
            <div>
              <div style={{ padding: "10px" }}>
                <TextField
                  sx={{ width: "99%" }}
                  id="outlined-required"
                  label="Interval Name"
                  inputProps={
                    {
                      "aria-label": "controlled",
                      "data-testid": "intervalName",
                    } as any
                  }
                  defaultValue={props.interval.name}
                  inputRef={inputRef}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleIntervalNameMapping(event.target.value);
                    setIntervalName(event.target.value);
                  }}
                />
              </div>
              <div style={{ padding: "10px" }}>
                <TextField
                  sx={{ width: "49%" }}
                  id="outlined-required"
                  label="Start Day"
                  defaultValue={props.interval.start_day}
                  inputProps={
                    {
                      "aria-label": "controlled",
                      "data-testid": "intervalStartDay",
                    } as any
                  }
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleStartDayMapping(event.target.value);
                  }}
                />
                <TextField
                  sx={{ width: "49%" }}
                  id="outlined-required"
                  label="End Day"
                  inputProps={
                    {
                      "aria-label": "controlled",
                      "data-testid": "intervalEndDay",
                    } as any
                  }
                  defaultValue={props.interval.end_day}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleEndDayMapping(event.target.value);
                  }}
                />
              </div>

              <div style={{ height: "1px", width: "1px", opacity: "0" }}>
                <TextField
                  sx={{ width: "99%" }}
                  id="outlined-required"
                  label="Interval Set"
                  inputProps={
                    {
                      "aria-label": "controlled",
                      "data-testid": "intervalIntervalSet",
                    } as any
                  }
                  defaultValue={intervalSetID}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleIntervalSetMapping(event.target.value);
                  }}
                />
              </div>
              {/* <div style={{ padding: "10px" }}>
                <TextField
                  sx={{ width: "99%" }}
                  id="outlined-required"
                  label="Interval Set"
                  inputProps={
                    {
                      "aria-label": "controlled",
                      "data-testid": "intervalIntervalSet",
                    } as any
                  }
                  defaultValue={intervalSetName}
                  value={intervalSetName}
                  disabled
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleIntervalSetMapping(event.target.value);
                  }}
                />
              </div> */}
              {(
                <div style={{ padding: "10px" }}>
                  <TextField
                    disabled={true}
                    inputProps={
                      {
                        "aria-label": "controlled",
                        "data-testid": "intervalCommunicationSet",
                      } as any
                    }
                    // keep this here to save the ID, but we dont need to show it.
                    sx={{
                      width: "1px",
                      neight: "1px",
                      opacity: "0",
                      padding: "0px",
                      margin: "0px",
                    }}
                    id="outlined-required"
                    label="Communication Set"
                    value={thisInterval.communication_set_id}
                    defaultValue={thisInterval.communication_set_id}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      handleCommunicationSetMapping(event.target.value);
                    }}
                  />
                  <TextField
                    disabled={true}
                    inputProps={
                      {
                        "aria-label": "controlled",
                        "data-testid": "intervalCommunicationSet",
                      } as any
                    }
                    // keep this here to save the ID, but we dont need to show it.
                    sx={{
                      width: "90%",
                      opacity: "1",
                      padding: "0px",
                      margin: "0px",
                    }}
                    id="outlined-required"
                    label="Communication Set"
                    value={commSet?.name || "None Assigned"}
                    defaultValue={commSet?.name || "None Assigned"}
                  />
                  {/* we want to override one handler for the in-intervalEditor version of this menu */}
                  <IntervalToCommSetButtonAndMenu
                    associatedInterval={props.interval}
                    editMode={false}
                    intervalSetName={props.intervalSet?.name || ""}
                    commSetsForIntervalSet={commSetsForThisIntervalSet}
                    inEditor={true}
                    handleOpenEditCommunications={handleOpenEditCommunications}
                  />
                </div>
              )}

              {/* interval */}
              {/* {<div style={{ padding: "10px", }}>
                <CommunicationSetEditor
                  resourceID={props.interval.id}
                  resourceName={"interval"}
                  communicationSetID={commSetID || -1}
                  intervalID={props.interval.id}
                  // currentParent={currentParent}
                  inDrawer={false}
                  drawerAccordion={true}
                  handleUpdateCommSet={handleUpdateCommSet}
                  intervalSetEditMode={props.intervalSetEditMode}
                />
              </div>} */}
              {/* override interval button */}
            </div>
            {isLoading && <LinearProgress />}
          </Grid>
        </Grid>
      </Box>
    </EditorWrapper>
  );
};

export default IntervalsEditor;
